import { memo } from "react";

import { modules } from "byzantine";

import styles from "./SearchBar.module.scss";
import SearchBarCollapsed from "./components/SearchBar.Collapsed";
import SearchBarExpanded from "./components/SearchBar.Expanded";
import { SearchBarProvider, useSearchBar } from "./context";

const { useIsGlobalSearchEnabled } = modules.search;

const SearchBarContent = () => {
  const { isOpen, toggleOpen } = useSearchBar();
  return (
    <>
      <div
        className={styles.container}
        role="button"
        tabIndex={0}
        onMouseDown={(e) => {
          if (isOpen) e.stopPropagation();
        }}
        onKeyDown={(e) => {
          if ((e.key === "Enter" || e.key === " ") && !isOpen) {
            e.preventDefault();
            toggleOpen();
          }
        }}
        onClick={() => {
          if (!isOpen) toggleOpen();
        }}
      >
        <SearchBarCollapsed />
      </div>
      {isOpen && <SearchBarExpanded />}
    </>
  );
};

const SearchBar = () => {
  const { isSearchEnabled } = useIsGlobalSearchEnabled();

  if (!isSearchEnabled) {
    // return an empty div to maintain space-between alignment
    return <div />;
  }

  return (
    <SearchBarProvider>
      <SearchBarContent />
    </SearchBarProvider>
  );
};

export default memo(SearchBar);
